export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/metronome-icon.svg?9bb8edff54f1c5f654940ac123f2c181";